import { Pipe, PipeTransform } from '@angular/core';
import { AssetUtils } from '../../../../../../../../../utils/asset-utils';
import { VariantsGroupedByBrand } from '../../../../../../../models/variants-grouped-by-brand';

@Pipe({
  name: 'glassHouseBrandFallback',
  standalone: false
})
export class GlassHouseBrandFallbackPipe implements PipeTransform {
  transform(variantsGroupedByBrand: VariantsGroupedByBrand): any {
    const productType = variantsGroupedByBrand?.productType();
    const variantType = variantsGroupedByBrand?.variantType();
    return AssetUtils.budSenseProductTypeUrls(productType, variantType);
  }
}
